import { render, staticRenderFns } from "./ArrivalNumber.vue?vue&type=template&id=8b595004&scoped=true"
import script from "./ArrivalNumber.vue?vue&type=script&lang=js"
export * from "./ArrivalNumber.vue?vue&type=script&lang=js"
import style0 from "./ArrivalNumber.vue?vue&type=style&index=0&id=8b595004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b595004",
  null
  
)

export default component.exports